var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.125 17.5156C0.125 21.4688 2.07812 23.8594 5.70312 24.3906L9.20312 32.1406C10.1406 34.2188 11.4688 35.25 13.4375 35.25C16.0156 35.25 17.8906 33.3594 17.3438 30.5156L16.2812 25.0469C20.6562 25.9219 25.0312 27.5312 29.1562 29.9062C29.8125 31.5469 31.375 32.6094 33.3438 32.6094C35.9688 32.6094 37.875 30.7031 37.875 28.0781V4.53125C37.875 1.90625 35.9688 0 33.3438 0C31.3125 0 29.7188 1.14062 29.0938 2.85938C24.2188 5.73438 18 7.67188 13.0312 8.21875H7.35938C2.67188 8.21875 0.125 10.7031 0.125 15.2031V17.5156ZM32.125 28.0781V4.53125C32.125 3.8125 32.625 3.3125 33.3438 3.3125C34.0625 3.3125 34.5625 3.8125 34.5625 4.53125V28.0781C34.5625 28.7969 34.0625 29.2969 33.3438 29.2969C32.625 29.2969 32.125 28.7969 32.125 28.0781ZM13.6875 21.2812V11.4219C19.1094 10.7656 24.2344 9.20312 28.8125 6.67188V26.0469C24.1562 23.4688 19.0781 21.9531 13.6875 21.2812ZM7.35938 21.1875C4.53125 21.1875 3.4375 20.1719 3.4375 17.5156V15.2031C3.4375 12.5625 4.53125 11.5469 7.35938 11.5469H10.375V21.1875H7.35938ZM12.3125 31.2188L9.15625 24.5H12.9375C12.9688 24.5156 12.9844 24.5156 13.0156 24.5156L14.2812 30.9219C14.4375 31.6562 14.0156 32.1094 13.4062 32.1094C12.8594 32.1094 12.5938 31.8281 12.3125 31.2188Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeta);
export default __webpack_public_path__ + "static/media/meta.25227229836152d5d631271ca4ff85a2.svg";
export { ForwardRef as ReactComponent };